import React, { useContext, useCallback } from 'react'
import { Box } from '@mui/material'
import Login from './auth/Login'
import { KeDoContext } from '../kedo-context'
import AppDialog from '@/shared/ui/app-dialog'

interface LoginModalProps {
    open: boolean
    handleLogin: (data: any) => void
}

interface KedoContextType {
    t: (key: string) => string
    api: () => {
        getGoogleConnect: () => string
        getAzureConnect: () => string
    }
}

const LoginModal: React.FC<LoginModalProps> = ({ open, handleLogin }) => {
    const kedo = useContext<KedoContextType>(KeDoContext)

    const handleSuccessfulAuth = useCallback(
        (data: any) => {
            handleLogin(data)
        },
        [handleLogin]
    )

    return (
        <AppDialog
            open={open}
            title={kedo.t('inactive_notification')}
            allowEsc={false}
            allowBackdropClick={false}
            maxWidth="sm"
            fullWidth
        >
            <Box className="login">
                <Login handleSuccessfulAuth={handleSuccessfulAuth} />
            </Box>
        </AppDialog>
    )
}

export default LoginModal
